export enum SiNoEnum {
    SI = <any>"SI",
    NO = <any>"NO",
}